import { createApiService } from "@/core/api/apiService";
import type {
  BusinessLocationDto,
  CreateBusinessLocationDto,
  UpdateBusinessLocationDto,
} from "../types/businessLocationTypes";

export function createBusinessLocationApiService() {
  const api = createApiService("locations");

  return {
    getAll: async (businessId: string): Promise<BusinessLocationDto[]> => {
      return api.get<BusinessLocationDto[]>(`/?businessId=${businessId}`);
    },

    getById: async (id: string): Promise<BusinessLocationDto> => {
      return api.get<BusinessLocationDto>(`/${id}`);
    },

    create: async (
      data: CreateBusinessLocationDto
    ): Promise<BusinessLocationDto> => {
      return api.post<BusinessLocationDto>("", data);
    },

    update: async (
      id: string,
      data: UpdateBusinessLocationDto
    ): Promise<BusinessLocationDto> => {
      return api.put<BusinessLocationDto>(`/${id}`, data);
    },

    delete: async (id: string): Promise<{ message: string }> => {
      return api.delete<{ message: string }>(`/${id}`);
    },
  };
}
const businessLocationApiService = createBusinessLocationApiService();
export { businessLocationApiService };
